export default {
  payWelfareText: '충전 혜택',
  blackFridayDiscount: '블랙프라이데이 한정 할인',
  shareGift: '공유 선물',
  vipWeeklyWelfare: 'VIP 매주 혜택',
  exchangeCoupon: '할인쿠폰 교환',
  firstPayOff: '첫 구매시 최대 15% 할인',
  blackFridayEvent: '블랙프라이데이 이벤트',
  limitedTimeOff: '10% 기간 한정 혜택',
  claimCoupon: '쿠폰 지금 받기',
  blackFridayTimedCoupon: '블랙프라이데이 한정 할인쿠폰',
  timeLeft: '이벤트 남은 시간:',
  claimTimeCoupon: '10% 기간 한정 할인쿠폰 받기',
  points: '남은 포인트: ${point}',
  costPointTip: '포인트를 소모하여 임의 등급의 할인쿠폰 교환 가능',
  maxPointTip: '매 계정 최대 500포인트 사용 가능',
  discountOff: '10% 할인',
  highestDiscount: '${discount} 최고 할인',
  needPoint: '수요 포인트 ${point}',
  changeCurrency: '화폐 종류 변경',
  claim: '수령',
  claimSucc: '수령 성공',
  claimFail: '수령 실패',
  pointNotEnough: '포인트 부족',
  afterClaimPoint: '수령 후 남은 포인트: ${point}',
  footTips1: '주문 건당 할인 쿠폰 한 장만 사용 가능',
  footTips2: '쿠폰 구매 시 할인 쿠폰 사용 불가',
  footTips3: '이벤트의 최종 해석권은 게임 운영진에게 있습니다.',
  ruleTitleText: '이벤트 규칙',
  ruleTime: '이벤트 시간: 2023-11-24 0:00 ～ 2023-11- 26 23:59 （UTC）',
  bfRuleText1:
    '1. 400 points will be granted to your account when you log in to the official top-up page for the first time during the event. You may exchange up to 500 points for coupons.',
  bfRuleText2:
    '2. You may exchange Black Friday points for the coupons during the event.',
  bfRuleText3:
    '3. 매 한건의 주문마다 할인쿠폰을 1장만 사용할 수 있습니다. 쿠폰 상품에는 블랙프라이데이 할인쿠폰이 지원되지 않습니다.',
  bfRuleText4: '4. 블랙프라이데이 할인쿠폰은 다음 화폐만 지원됩니다.',
  ableCoinsType:
    'USD, JPY, KRW, TWD, EUR, HKD, GBP, CAD, AUD, RUB, MYR, THB, PLN, IDR.',
  bfRuleText5:
    '5. 교환 후, 화폐종류 변경은 지원되지 않으며, 포인트반환도 지원되지 않습니다. 혜택 한도와 포인트소모에 주의하시기 바랍니다.',
  bfRuleText6:
    '6. 블랙프라이데이 할인쿠폰의 유효기간은 7일이니 주의하여 사용하시기 바랍니다.',
  bfRuleText7: '7. 이벤트의 최종 해석권은 게임 운영진에게 있습니다.',
  thanksTip:
    '참여해 주셔서 감사합니다, 더 많은 결제 이벤트는 공식 커뮤니티에 관심 가져주시기 바랍니다.',
  exchangePoints: '할인 쿠폰 교환',
  exchangeCode: '결제 방식을 선택하신 후 할인 코드를 입력해주세요',
  enterExchangeCode: '여기에 할인 코드 입력하기',
  exchangeText: '교환',
  confirmGet: '수령 확인',
  couponUsedWay:
    '쿠폰은 지정된 화폐의 결제 채널에서만 사용 가능하오니 사용하실 결제화폐를 확인하시기 바랍니다',
  confirmText: '확인',
  exchangeSucc: '교환 성공',
  aboutCoins: '쿠폰에 대해서',
  aboutCoinsText:
    '쿠폰은 게임 내 쿠폰을 제외한 모든 상품의 교환과 부가 서비스 등에 사용된다',
  known: '알겠습니다',
  codeText: '교환 코드',
  codeInvalid: '무효한 쿄환 코드입니다!',
  hasExchanged: '이미 교환했습니다. 해당 교환 코드는 1회만 교환 가능합니다.',
  hideText: '숨기기',
  //黑五的报错码
  'bf-20001': '미로그인',
  'bf-20002': '파라미터 오류. 게임 화면을 갱신하세요.',
  'bf-20003': '포인트 부족',
  'bf-20004': '수령 실패. 잠시 후 시도하거나 고객센터에 문의하세요',
  'bf-20005': '수령 완료',
  'bf-20015': '이벤트 오픈 전, 기대해 주세요!',
  'bf-20016': '이벤트가 종료되었습니다',
  bfShareText: '10% 기간 한정 할인쿠폰 받기',
  rightsCenterBtn: '프리미엄 센터',
  payBtn: '결제',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : '비범한 명예(영구)',
  rightCenterNoticeTitle: 'VIP 포인트 시스템이 [혜택 센터]로 업그레이드됩니다',
  rightCenterNoticeContent: "지휘관님께:<br />그동안 보내주신 성원에 깊이 감사드립니다! 지휘관님께 더 나은 혜택 경험을 제공해 드리기 위해 2025년 6월 26일부터 기존 VIP 포인트 시스템을 전면 개편하고, 새로운 「혜택 센터」 시스템을 도입할 예정입니다. 이번 개편에서는 기존 VIP 혜택을 통합하고 더 많은 혜택이 추가됩니다. 구체적인 변경 사항은 다음과 같습니다.<br />1. 개편 내용 설명<br />주간 로그인 혜택 유지<br />2025년 6월 26일부터 7월 9일까지 모든 유저가 [공식 사이트 충전 페이지]에 접속하면 계속해서 '주간 VIP 쿠폰'을 받을 수 있습니다. 획득 가능한 쿠폰 수량은 [VIP 포인트 이벤트]와 동일합니다. 또한 모든 유저는 [혜택 센터]에서 새로운 버전의 쿠폰으로 교환할 수 있습니다. 혜택 센터 쿠폰에는 최대 할인 금액 제한이 적용됩니다. 새로운 쿠폰 규칙 및 획득 가능 수량은 페이지 하단의 표를 참조하시기 바랍니다.<br />주의 사항: 쿠폰 자동 발급 기능은 수동으로 활성화해야 합니다. <br />활성화 경로: 혜택 센터 홈 - 회원 혜택 보기 - 쿠폰 자동 발급 - 활성화 클릭 - 자동 교환할 쿠폰 선택 - 활성화 확인<br />포인트 교환 혜택 추가<br />혜택 센터에서 '포인트 교환' 기능이 오픈됩니다. 게임 로그인, 혜택 센터에서 지정한 퀘스트 완료 등의 방식으로 포인트를 획득할 수 있습니다. 이는 전용 쿠폰, 희귀 아이템 등 초특가 보상으로 교환할 수 있습니다(교환 가능 수량의 구체적인 내용은 혜택 센터에서 확인 가능).<br />VIP 레벨 계승 보장<br />기존 VIP 레벨 및 누적 포인트는 혜택 센터로 완전히 계승되며, 해당 혜택 센터의 레벨로 자동 전환됩니다. 기존 VIP 특권은 그대로 유지되는 동시에 최적화 및 업그레이드됩니다.<br />2. 개편 후 장점<br />더욱 투명한 혜택: 모든 혜택 규칙과 교환 내용이 명확히 표시되며, 일괄로 수령할 수 있습니다.<br />더욱 푸짐한 보상: 새로운 포인트 교환 이벤트가 추가되며, 고가치 아이템이 수시로 업데이트됩니다.<br />추첨 혜택: 포인트 교환 외에도 추첨 이벤트가 추가되어 게임 내 아이템 보상을 획득할 수 있습니다.<br />3. 유의 사항<br />개편 전환 기간(2025년 6월 26일-7월 9일) 동안 기존 VIP 포인트 입구가 단계적으로 폐쇄됩니다(단, 폐쇄 전까지는 정상적으로 쿠폰 발급). 남은 쿠폰을 빠른 시일 내에 사용해 주시기 바랍니다. [VIP 포인트 이벤트] 종료 후 미사용 쿠폰은 무효 처리됩니다.<br />혜택 센터 오픈 후 [공식 충전 센터] - [프로필]을 통해 [혜택 센터]에 접속할 수 있습니다.",
  rightCenterNoticeTableTitle: '서드 파티 쿠폰 변경 비교',
  rightCenterNoticeTableHeader1: '교환 조건 - 프리미엄 레벨',
  rightCenterNoticeTableHeader2: '원래 VIP 레벨',
  rightCenterNoticeTableHeader3: '쿠폰 할인',
  rightCenterNoticeTableHeader4: '획득 제한',
  rightCenterNoticeTableHeader5: '할인 한도',
  rightCenterNoticeTableLevel1: '브론즈',
  rightCenterNoticeTableLevel2: '실버', 
  rightCenterNoticeTableLevel3: '골드',
  rightCenterNoticeTableLevel4: '플래티넘',
  rightCenterNoticeTableLevel5: '다이아',
  rightCenterNoticeTableCount1: '1회/일',
  rightCenterNoticeTableCount2: '15회/월',
  rightCenterNoticeTableCount3: '10회/월',
  rightCenterNoticeTableLimit: '15USD',
  rightCenterNoticeTableTip: '주의: [혜택 센터] 쿠폰의 할인 한도는 USD 기준이며, 환율 변동의 영향을 받습니다. 실제 사용 페이지에 표시된 내용을 기준으로 합니다.',
  '-': '-'
};
